export default __webpack_public_path__ + "static/centralized-platform-b58ed1c1839c292173dcae9f4497f053.svg";